export type ReportLocale = 'pt' | 'es';

const SPANISH_TOKENS = new Set([
  'es',
  'es-es',
  'es_es',
  'es-mx',
  'es_mx',
  'es-ar',
  'es_ar',
  'es-cl',
  'es_cl',
  'es-co',
  'es_co',
  'spanish',
  'espanhol',
  'espanol',
]);

function asString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function normalizeToken(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export interface ReportLocaleSource {
  language?: unknown;
  locale?: unknown;
  language_code?: unknown;
  lang?: unknown;
  partner_name?: unknown;
  metadata?: Record<string, unknown> | null;
}

function collectCandidates(source: ReportLocaleSource): string[] {
  const metadata = source.metadata ?? {};
  return [
    source.lang,
    source.language,
    source.locale,
    source.language_code,
    metadata.lang,
    metadata.language,
    metadata.locale,
    metadata.language_code,
  ]
    .map(asString)
    .filter((value): value is string => value !== null);
}

export function normalizeReportLang(value: unknown): ReportLocale {
  const token = asString(value);
  if (!token) {
    return 'pt';
  }

  const normalized = normalizeToken(token);
  if (SPANISH_TOKENS.has(normalized) || normalized.startsWith('es')) {
    return 'es';
  }

  return 'pt';
}

export function resolveReportLocale(source: ReportLocaleSource): ReportLocale {
  const [first] = collectCandidates(source);
  if (!first) {
    return 'pt';
  }

  return normalizeReportLang(first);
}
